/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'format-align-middle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13 6l2-2 1.42 1.42L12 9.84 7.58 5.42 9 4l2 2V2h2v4M3 11h18v2H3v-2m10 7v4h-2v-4l-2 2-1.42-1.42L12 14.16l4.42 4.42L15 20l-2-2z"/>'
  }
})
